export function stringValue(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function lineCount(text: string | null): number {
  if (text === null || text.length === 0) return 0;
  const lines = text.split(/\r?\n/).length;
  return text.endsWith('\n') ? lines - 1 : lines;
}
